export default "__VITE_ASSET__0b6d5518__"